import fromPairs from 'lodash/fromPairs';
import {
  PLACEHOLDER_OPT,
} from '../Forms/Schemas/baseRrf';

export const myIPOAccountID = '0';

export const getAccountOptsFromBankLinks = (links) => {
  const linkPairs = links.filter(link =>
    (link.verifyStatus && link.status === 'A')).map(link =>
    ([link.bankLinkOid, `${link.bankName} ${link.bankAccountNumber}`]));
  linkPairs.push([myIPOAccountID, 'My IPO']);
  linkPairs.push([PLACEHOLDER_OPT, 'Select an account']);
  return fromPairs(linkPairs);
};



// WEBPACK FOOTER //
// ./src/components/TransferFunds/utils.js